




import { Component, Vue } from 'vue-property-decorator'
import constants from '@/utils/constants'
import api from '@/api'

const OrderStatusType = {
  paymentSuccess: 'paymentSuccess',
  voidSuccess: 'voidSuccess'
}

@Component
export default class ChangeOrderStatus extends Vue {
  $swal: any

  mounted() {
    // CIMB payment APP success callback on android webview
    (window as any).cimbGenerateQRSuccess = this.cimbGenerateQRSuccess;
    (window as any).cimbPaymentSuccess = this.cimbPaymentSuccess;
    (window as any).cimbVoidSuccess = this.cimbVoidSuccess
  }

  beforeDestroy() {
    if ((window as any).cimbPaymentSuccess) {
      delete (window as any).cimbPaymentSuccess
    }
    if ((window as any).cimbVoidSuccess) {
      delete (window as any).cimbVoidSuccess
    }
  }

  cimbGenerateQRSuccess(orderId: string, traceNo: string, referenceId: string) {
    this.callCimbPaymentCallback({
      orderId,
      traceNo,
      referenceId
    })
  }

  async callCimbPaymentCallback(payload) {
    sessionStorage.setItem('payCallBackInfo', JSON.stringify(payload))
    // try {
    //   // Call the API to update order callback
    //   const res = await api.ChangeCIMBOrderCallback(payload)
    //
    //   if (res.data.message !== constants.UPPER_SUCCESS) {
    //     this.$swal(
    //       constants.SOMETHING_WROING,
    //       res.data.message,
    //       constants.STATUS_ERROR
    //     )
    //   }
    // } catch (error) {
    //   this.$swal(
    //     constants.SOMETHING_WROING,
    //     error.message,
    //     constants.STATUS_ERROR
    //   )
    // }
  }

  cimbPaymentSuccess(orderId: string, traceNo: string, referenceId: string) {
    this.callCimbPaymentSuccess({
      orderId,
      traceNo,
      referenceId
    })
  }

  async callCimbPaymentSuccess(data) {
    const { orderId, traceNo, referenceId } = data
    try {
      let orderStatus = 'COMPLETED'
      // Call the API to update order status
      const payload = {
        orderId,
        traceNo,
        referenceId,
        orderStatus
      }
      const res = await api.ChangeCIMBOrderStatus(payload)

      if (res.data.message === constants.UPPER_SUCCESS) {
        this.$swal(
          constants.UPPER_SUCCESS,
          'Order status already changed',
          constants.STATUS_SUCCESS
        )
      } else {
        this.$swal(
          constants.SOMETHING_WROING,
          res.data.message,
          constants.STATUS_ERROR
        )
      }
    } catch (error) {
      this.$swal(
        constants.SOMETHING_WROING,
        error.message,
        constants.STATUS_ERROR
      )
    }
  }

  cimbVoidSuccess(orderId: string) {
    const payload = { orderId }
    this.$store.dispatch('CancelOrder', payload)
    this.$swal(
      constants.UPPER_SUCCESS,
      'Order status already changed',
      constants.STATUS_SUCCESS
    )
  }
}
